/**
 * Agent log drawer accordion chrome from Figma (Collect-execution-to-Agent-Dataset).
 * Shadow applies only to outer section panels (Execution logs, Output), not inner log rows.
 */
export const agentLogDrawerSectionAccordionItemClasses = {
  base: 'rounded-lg bg-surface px-4 py-3.5 shadow-small',
  trigger: 'min-h-5 bg-transparent px-0 py-0 data-[hover=true]:bg-transparent',
  titleWrapper: 'px-0',
  indicator: 'text-on-surface [&_svg]:h-5 [&_svg]:w-5',
  content: 'gap-3 border-t border-outline px-0 pb-0 pt-3.5'
} as const;

export const monitorLogCardItemClasses = {
  base: 'min-w-0 overflow-clip rounded-md bg-surface-dim',
  trigger:
    'min-w-0 bg-transparent px-2 py-2 pr-3.5 hover:bg-surface-hover data-[hover=true]:bg-surface-hover',
  content: 'min-w-0 overflow-clip px-2 pb-2 pt-0'
} as const;
